import React, { useState } from "react";
import { Redirect, Link } from "react-router-dom";
import { useStoreState, useStoreActions } from "easy-peasy";
import useDocumentTitle from "../hooks/useDocumentTitle";
import FormikInput from "./FormikInput";
import SignupSchema from "./SignupSchema";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Input,
} from "reactstrap";
import { Form, Formik } from "formik";

const Signup = ({ signup, ...props }) => {
  const [submitted, setSubmitted] = useState(false);
  const addToast = useStoreActions((actions) => actions.toasts.addToast);
  const loggedIn = useStoreState((state) => state.auth.loggedIn);

  const handleSignup = async (values) => {
    await signup(values).then(
      (res) => {
        console.log(res);
        addToast({
          color: "info",
          message: "Please check your email to activate your account",
        });
        setSubmitted(true);
      },
      (err) => {
        switch (err.response.status) {
          case 405:
            addToast({
              color: "danger",
              message: "Email already taken. Please use a different email",
            });
            console.error(err.response);
            break;
          default:
            console.error(err.response);
            addToast({
              color: "danger",
              message: "Error Creating Account",
            });
            break;
        }
      }
    );
  };

  useDocumentTitle("Sign Up");
  return (
    <>
      {loggedIn ? (
        <Redirect to="/home" />
      ) : submitted ? (
        <Redirect to="/signup" />
      ) : (
        <Row className="h-100">
          <Col xs={12} lg={4} className="mx-auto">
            <Card style={{ marginTop: "20%" }}>
              <CardHeader className="theme-blue"></CardHeader>
              <CardBody>
                <Formik
                  initialValues={{
                    name: "",
                    email: "",
                    password: "",
                    passwordConfirmation: "",
                  }}
                  validationSchema={SignupSchema}
                  onSubmit={(values) => handleSignup(values)}
                >
                  {({ isSubmitting, errors, touched }) => (
                    <Form>
                      <h2 className="text-center">Sign Up</h2>
                      <Row form>
                        <Col xs={12}>
                          <FormikInput
                            type="text"
                            touched={touched}
                            errors={errors}
                            name="name"
                            label="Full Name"
                            placeholder="Enter a name"
                            as={Input}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col xs={12}>
                          <FormikInput
                            type="email"
                            touched={touched}
                            errors={errors}
                            name="email"
                            label="Email"
                            placeholder="Enter your email address"
                            as={Input}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col xs={12}>
                          <FormikInput
                            type="password"
                            touched={touched}
                            errors={errors}
                            name="password"
                            label="Password"
                            placeholder="Create a password"
                            as={Input}
                          />
                        </Col>
                      </Row>

                      <Row form>
                        <Col xs={12}>
                          <FormikInput
                            type="password"
                            touched={touched}
                            errors={errors}
                            name="passwordConfirmation"
                            placeholder="Confirm your password"
                            label="Password Confirmation"
                            as={Input}
                          />
                        </Col>
                      </Row>

                      <Button
                        type="submit"
                        className="w-100 theme-blue"
                        disabled={isSubmitting}
                      >
                        Start Logging
                      </Button>
                      <Row className="align-items-center">
                        <Col xs={12} className="text-center pt-2">
                          Already have an account?{" "}
                          <Link to="/login">Login</Link>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Signup;
